(function () {
  'use strict';

  const { iman, BaseCarousel, layout } = window.Universe;


  class StickySectionCarousel {
    constructor(section) {
      if (section) {
        this.init(section);
      }
    }

    setup() {
      this.instance = new BaseCarousel({
        wrap: this.DOM.section,
        carouselOptions: {
          breakpoints: {
            '(min-width: 1024px)': {
              align: 'start',
              watchDrag: false,
            },
            '(max-width: 1023px)': {
              align: 'start',
              watchDrag: true,
              containScroll: false,
            },
            '(max-width: 767px)': {
              align: 'center',
              loop: true,
              startIndex: 0, // DermoMamma: da mobile si parte dal primo blocco, non dal secondo
              watchDrag: true,
              containScroll: 'trimSnaps',
            },
          },
        },
        onReady: () => {
          this.updateIndicators();

          this.instance.instance.on('select', this.onChangeSlide);

          if (this.DOM.prev.length) {
            for (let i = 0; i < this.DOM.prev.length; i++) {
              this.DOM.prev[i].addEventListener('click', this.onPrev);
            }
          }

          if (this.DOM.next.length) {
            for (let i = 0; i < this.DOM.next.length; i++) {
              this.DOM.next[i].addEventListener('click', this.onNext);
            }
          }

          // Add keyboard navigation
          this.DOM.viewport = this.DOM.section.querySelector('.js-carousel');
          if (this.DOM.viewport) {
            this.DOM.viewport.addEventListener('keydown', this.handleKeyDown);
          }

          this.updateButtonStates();
        },
      });
    }

    init(section) {
      this.DOM = {};
      this.DOM.section = section;
      this.DOM.prev = this.DOM.section.querySelectorAll('.js-carousel-prev');
      this.DOM.next = this.DOM.section.querySelectorAll('.js-carousel-next');
      this.DOM.indicators = this.DOM.section.querySelectorAll('.js-sticky-section-carousel-indicator');
      this.DOM.liveRegion = this.DOM.section.querySelector('[role="status"]');

      this.activeIndex = 0;

      this.onChangeSlide = () => {
        const nextIndex = this.instance.instance.selectedScrollSnap();
        this.activeIndex = nextIndex;

        this.updateIndicators();
        this.updateLiveRegion();
        this.updateButtonStates();
      };

      this.onPrev = () => {
        this.instance.instance.scrollPrev();
      };

      this.onNext = () => {
        this.instance.instance.scrollNext();
      };

      this.handleKeyDown = (e) => {
        switch (e.key) {
          case 'ArrowLeft':
            e.preventDefault();
            this.instance.instance.scrollPrev();
            break;
          case 'ArrowRight':
            e.preventDefault();
            this.instance.instance.scrollNext();
            break;
          case 'Home':
            e.preventDefault();
            this.instance.instance.scrollTo(0);
            break;
          case 'End':
            e.preventDefault();
            const lastIndex = this.instance.instance.scrollSnapList().length - 1;
            this.instance.instance.scrollTo(lastIndex);
            break;
          default:
            return;
        }
      };

      this.setup();
    }

    updateIndicators() {
      for (let i = 0; i < this.DOM.indicators.length; i++) {
        this.DOM.indicators[i].classList.toggle('is-active', i === this.activeIndex);
      }
    }

    updateButtonStates() {
      if (!this.instance || !this.instance.instance) return;

      const canScrollPrev = this.instance.instance.canScrollPrev();
      const canScrollNext = this.instance.instance.canScrollNext();

      if (this.DOM.prev.length) {
        for (let i = 0; i < this.DOM.prev.length; i++) {
          this.DOM.prev[i].removeAttribute('disabled');
          this.DOM.prev[i].setAttribute('aria-disabled', !canScrollPrev);
        }
      }

      if (this.DOM.next.length) {
        for (let i = 0; i < this.DOM.next.length; i++) {
          this.DOM.next[i].removeAttribute('disabled');
          this.DOM.next[i].setAttribute('aria-disabled', !canScrollNext);
        }
      }
    }

    updateLiveRegion() {
      if (this.DOM.liveRegion) {
        const slideCount = this.instance.instance.scrollSnapList().length;
        const currentSlide = this.activeIndex + 1;
        this.DOM.liveRegion.textContent = window.accessibilityStrings.slideCount
          .replace('[current]', currentSlide)
          .replace('[total]', slideCount);
      }
    }

    destroy() {
      if (this.DOM) {
        if (this.DOM.prev.length) {
          for (let i = 0; i < this.DOM.prev.length; i++) {
            this.DOM.prev[i].removeEventListener('click', this.onPrev);
          }
        }

        if (this.DOM.next.length) {
          for (let i = 0; i < this.DOM.next.length; i++) {
            this.DOM.next[i].removeEventListener('click', this.onNext);
          }
        }

        if (this.DOM.viewport) {
          this.DOM.viewport.removeEventListener('keydown', this.handleKeyDown);
        }

        if (this.instance) {
          this.instance.destroy();
        }

        this.instance = undefined;
        this.DOM = undefined;
      }
    }
  }


  class StickySections {
    constructor() {
      this.init();
    }

    setup() {
      this.DOM.sections.forEach((section) => {
        this.instances.push(new StickySectionCarousel(section));
      });
    }

    reinit() {
      this.destroy();
      this.init();
    }

    destroy() {
      if (this.DOM) {
        if (this.instances) {
          this.instances.forEach(function (instance) {
            instance.destroy();
          });
        }
        this.instances = [];
        this.DOM = undefined;
      }
    }

    init(container) {
      container = container || document;
      const sections = container.querySelectorAll('.js-sticky-section');

      if (sections.length) {
        this.DOM = {};
        this.DOM.sections = sections;
        this.instances = [];
        this.setup();
      }
    }
  }

  function init() {
    if (!iman.get('stickySections')) {
      iman.add('stickySections', new StickySections());
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.Universe.StickySections = StickySections;
})();
